<script lang="ts">
  import { AppState } from '../../etc/stores';
  const { quaternary, secondary, firstStopColor } =
    $AppState.theme.colors.illustration;
</script>

<svg
  width="88"
  height="88"
  viewBox="0 0 88 88"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="44" cy="44" r="44" fill="url(#paint0_linear_4747:39122)" />
  <path
    d="M43.9999 70.6667C58.7275 70.6667 70.6666 58.7276 70.6666 44C70.6666 29.2724 58.7275 17.3334 43.9999 17.3334C29.2723 17.3334 17.3333 29.2724 17.3333 44C17.3333 58.7276 29.2723 70.6667 43.9999 70.6667Z"
    fill="url(#paint1_linear_4747:39122)"
  />
  <path
    d="M44 28V44L54.6667 49.3333"
    stroke="white"
    stroke-width="4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <defs>
    <linearGradient
      id="paint0_linear_4747:39122"
      x1="44"
      y1="0"
      x2="44"
      y2="88"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color={firstStopColor} />
      <stop offset="1" stop-color={firstStopColor} stop-opacity="0" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_4747:39122"
      x1="60.036"
      y1="-51.5555"
      x2="6.4266"
      y2="-45.6474"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={secondary} />
      <stop offset="1" stop-color={quaternary} />
    </linearGradient>
  </defs>
</svg>
